import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./creategroup.css";
import axios from "../../axios";
import { MultiSelect } from "react-multi-select-component";
import { Popup } from "semantic-ui-react";
import Form from "react-bootstrap/Form";
import CreateGroupError from "./CreateGroupError";
import { toast } from "react-toastify";
import assets from "../../assets/assets";

export default function CreateGroup() {
  const navigate = useNavigate();
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [profile, setProfile] = useState("");
  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [stand, setStand] = useState("");
  const [sec, setSec] = useState("");
  const [sub, setSub] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [createError, setCreateError] = useState(false);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const [standardArr, setStandardArr] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON =
    JSON.parse(general_role) === null ? [] : JSON.parse(general_role);
  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON =
    JSON.parse(classTeacher) === null ? [] : JSON.parse(classTeacher);
  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON =
    JSON.parse(cordinator) === null ? [] : JSON.parse(cordinator);
  const [sortedSections, setSortedSections] = useState([]);
  const [sortedStandards, setSortedStandards] = useState([]);
  const [dropdownLists, setDropdownLists] = useState({
    standards: [],
    sections: [],
    assessmentTypes: null,
    subjects: [],
  });
  const { standards, sections, subjects } = dropdownLists;
  useEffect(() => {
    let students = [];
    if (!timeTableSessionId) {
      return;
    }
    const getStudentList = async () => {
      try {
        let res = await axios.get(
          `/api/v1/school/student/getList?standardId=${stand}&sectionId=${sec}&timetableSession=${timeTableSessionId}`,
        );

        console.log(res, "res");
        res &&
          res.data.data.map((student) =>
            students.push({ value: student.id, label: student.name }),
          );

        setStudentList(students);
      } catch (error) {
        console.log(error);
      }
    };

    console.log(studentList, "studentList");

    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stand, sec]);

  async function create() {
    let students_id = [];
    for (const student of selectedList) {
      students_id.push(student.value);
    }
    console.log(students_id);
    let profile_picture;
    if (profile) {
      const formData = new FormData();
      formData.append("name", profile.name);
      formData.append("uploadGroupAttachment", profile);
      try {
        const res = await axios.post(
          `/api/v1/group/uploadAttachment/teacherId/${teacher_id}`,
          formData,
        );
        profile_picture = res.data.data;
      } catch (error) {
        console.log(error);
      }
    }

    try {
      let timeTableSessionId = JSON.parse(
        localStorage.getItem("timeTableSessionId"),
      );
      if (!timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      const res = await axios.post(`/api/v1/group/create`, {
        teacher_id: teacher_id,
        name: name,
        standard_id: stand,
        section_id: sec,
        type: "Query",
        subject_id: sub,
        description: description,
        profile_picture: profile_picture,
        members: {
          students: students_id,
        },
        timetableSessionID: timeTableSessionId,
      });
      res && navigate("/queryGroups");
    } catch (err) {
      setErrorMessage(err.response.data.message);
      setCreateError(true);
      console.log(err);
    }
  }

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  // useEffect(() => {
  //   if (CTRole_Information && CTRole_Information.length > 0) {
  //     CTRole_Information?.forEach((obj) => {
  //       if (!standards.some((i) => i.id === obj.standard_id.id)) {
  //         standards.push(obj.standard_id);
  //       }
  //       if (!sections.some((i) => i.id === obj.section_id.id)) {
  //         sections.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (CoRole_Information && CoRole_Information.length > 0) {
  //     CoRole_Information?.forEach((obj) => {
  //       if (!standards.some((i) => i.id === obj.standard_id.id)) {
  //         standards.push(obj.standard_id);
  //       }
  //       if (!sections.some((i) => i.id === obj.section_id.id)) {
  //         sections.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (general_role && general_role.length > 0) {
  //     general_role?.forEach((obj) => {
  //       if (!standards.some((i) => i.id === obj.standard_id.id)) {
  //         standards.push(obj.standard_id);
  //       }
  //       if (!sections.some((i) => i.id === obj.section_id.id)) {
  //         sections.push(obj.section_id);
  //       }
  //     });
  //   }
  //   standards.length > 0 &&
  //     setDropdownLists({
  //       ...dropdownLists,
  //       standards,
  //     });

  //   if (sections.length > 0) {
  //     setDropdownLists({
  //       ...dropdownLists,
  //       sections,
  //     });
  //   }
  // }, []);

  // useEffect(() => {
  //   const getLIst = async () => {
  //     try {
  //       let standard = await axios.get(`/api/v1/school/standard/get`);
  //       let section = await axios.get(`/api/v1/school/section/get`);
  //       // let subject = await axios.get(`/api/v1/school/subject/get`);
  //       setDropdownLists((prev) => ({
  //         ...prev,
  //         standards: standard.data.data,
  //         // subjects: subject.data.data,
  //         sections: section.data.data,
  //       }));
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   getLIst();
  // }, []);

  let tempSectionArr = [];
  function addUniqueObjectToArraystand(obj) {
    if (
      !standardArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
    ) {
      standardArr.push(obj);
    }
  }
  const dropDownHelper = () => {
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
    setStandardArr([...standardArr]);
  };

  function addUniqueObjectToArraysect(obj) {
    if (
      !tempSectionArr.some(
        (item) => JSON.stringify(item) === JSON.stringify(obj),
      )
    ) {
      tempSectionArr.push(obj);
    }
  }

  const handleDropDownSec = () => {
    const selectedStandardId = stand;
    tempSectionArr = [];
    generalRole_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    setSectionArr([...tempSectionArr]);
  };

  useEffect(() => {
    dropDownHelper();
    setSectionArr([]);
    handleDropDownSec();
  }, [stand]);

  console.log("sectionArr", sectionArr);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      let res = await axios.get(
        `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
      );

      const data = res?.data?.data;

      // Priority: subjectConfigurations > subjects
      const subjectSource =
        data?.subjectConfigurations?.length > 0
          ? data.subjectConfigurations.map((item) => item.subject)
          : data.subjects;

      subjectSource.forEach((obj) => {
        arrSubject.push(obj);
      });
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };
  const subjectList = [];

  useEffect(() => {
    (async () => {
      let subjects = [];
      if (
        ((classTeacher_JSON && classTeacher_JSON.length > 0) ||
          (classTeacher_JSON && classTeacher_JSON.length > 0)) &&
        stand !== "null" &&
        sec !== "null"
      ) {
        subjects = await getSubjects(stand, sec); //obj.subjects_id;
      }
      if (classTeacher_JSON && classTeacher_JSON.length > 0) {
        classTeacher_JSON?.forEach(async (obj) => {
          if (obj.standard_id.id === stand && obj.section_id.id === sec) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (cordinator_JSON && cordinator_JSON.length > 0) {
        cordinator_JSON?.forEach(async (obj) => {
          if (obj.standard_id.id === stand && obj.section_id.id === sec) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (generalRole_JSON && generalRole_JSON.length > 0) {
        generalRole_JSON?.forEach((obj) => {
          let subjects = obj.subjects_id;
          if (obj.standard_id.id === stand && obj.section_id.id === sec) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        });
      }

      subjectList.length > 0 &&
        setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stand, sec]);

  // useEffect(() => {
  //   if (standardArr && sectionArr) {
  //     const sortedStd = [...standardArr].sort((a, b) => {
  //       const nameA = a.name.toUpperCase();
  //       const nameB = b.name.toUpperCase();
  //       return nameA.localeCompare(nameB);
  //     });

  //     const sortedSec = [...sectionArr].sort((a, b) => {
  //       const nameA = a.name.toUpperCase();
  //       const nameB = b.name.toUpperCase();
  //       return nameA.localeCompare(nameB);
  //     });

  //     setSortedStandards(sortedStd);
  //     setSortedSections(sortedSec);
  //   }
  // }, [stand, sec]);

  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (
      !allowedExtensions.exec(filePath.name) ||
      filePath.size > 10 * 1024 * 1024
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const imageHandler = (e) => {
    let totalSize = e.target.files[0]?.size;
    if (totalSize <= 10 * 1024 * 1024 && validateFileType(e.target.files[0])) {
      setProfile(e.target.files[0]);
      setShowPopup(false);
    } else {
      setShowPopup(false);
      window.alert(
        "File Size should be less than 10 mb & only supported file type is jpg,jpeg,png. ",
      );
    }
  };

  return (
    <div className="w-100 h-100">
      <div
        className="d-flex flex-column gap-1 ms-4 "
        style={{
          cursor: "pointer",
        }}
        onClick={() => navigate(-1)}
      >
        <span className="head_manual">Create Group</span>
        <span className="fw-small  text-muted" style={{ fontSize: "10px" }}>
          Dashboard / Student Query / Create Groups
        </span>
      </div>
      <div
        className="p-4  m-4 orange-scrollBar"
        style={{
          backgroundColor: "white",
          height: "calc(100vh - 200px)",
          overflowY: "scroll",
        }}
      >
        <h4 className="poppins-semibold">Create Groups</h4>

        <div className="d-flex flex-column gap-2 align-items-start justify-content-start mt-4">
          <input
            style={{ paddingLeft: "12px", width: "90%" }}
            className="input_group1 "
            id={name ? "byeInput" : "belloInput"}
            placeholder="Enter Name"
            onChange={(e) => setName(e.target.value)}
            maxLength={50}
          ></input>

          <div className="w-100">
            <div
              className="d-flex gap-4 w-100"
              style={{ display: "flex", marginTop: "9px" }}
            >
              {/* <Form.Select
              style={{ color: "#668598", height: "40px", width: "40.8%" }}
              // className="form-select mr-4"
              className="query_field_box py-2 mr-4"
              id={stand ? "bye" : "bello"}
              onChange={(e) => setStand(e.target.value)}
            >
              <option selected>Select class</option>
              {standards?.length > 0 &&
                standards?.map((standard, index) => (
                  <option
                    key={index}
                    value={standard?.id}
                    name={standard?.name}
                  >
                    {standard?.name}
                  </option>
                ))}
            </Form.Select> */}
              <select
                style={{ color: "#668598", height: "45px", width: "44%" }}
                className="form-select "
                id={stand ? "bye" : "bello"}
                onChange={(e) => {
                  let standardId = e.target.value.split(",")[1];
                  setStand(standardId);
                  setSelectedList([]);
                  setSectionArr([]);
                }}
              >
                <option value="">Select Class</option>
                {standardArr &&
                  standardArr
                    ?.sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    ?.map((item) => (
                      <option key={item.id} value={[item.name, item.id]}>
                        {item.name}
                      </option>
                    ))}
              </select>

              {/* <Form.Select
              style={{ color: "#668598", height: "40px", width: "40.8%", }}
              // className="form-select"
              className="query_field_box py-2"
              id={sec ? "bye" : "bello"}
              onChange={(e) => setSec(e.target.value)}
            >
              <option selected>Select Section</option>
              {sections?.length > 0 &&
                sections?.map((section, index) => (
                  <option
                    key={index}
                    value={section?.id}
                    name={section?.name}
                  >
                    {section?.name}
                  </option>
                ))}
            </Form.Select> */}
              <select
                style={{ color: "#668598", height: "45px", width: "43.5%" }}
                className="form-select "
                id={sec ? "bye" : "bello"}
                onChange={(e) => {
                  let sectionId = e.target.value.split(",")[1];
                  setSec(sectionId);
                  setSelectedList([]);
                }}
              >
                <option value="">Select Section</option>
                {sectionArr?.map((item) => (
                  <option key={item.id} value={[item.name, item.id]}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Hide the group type selection */}
            <div
              className="gap-4"
              style={{ display: "flex", marginTop: "9px", width: "100%" }}
            >
              {/* Hide Group type select */}
              {/* <select
              style={{ color: "#668598", height: "45px" }}
              className="form-select "
              id={typ ? "bye" : "bello"}
              onChange={(e) => setTyp(e.target.value)}
            >
              <option value="">Select Group Type</option>
              <option value="Query">Query</option>
              <option value="Community">Community</option>
              <option value="General">General</option>
            </select> */}
              <select
                style={{ color: "#668598", height: "45px", width: "44%" }}
                className="form-select "
                id={sub ? "bye" : "bello"}
                onChange={(e) => setSub(e.target.value)}
              >
                <option value="">Select Subject</option>
                {subjects?.length > 0 &&
                  subjects?.map((subject, index) => (
                    <option
                      key={index}
                      value={subject?.id}
                      name={subject?.name}
                    >
                      {subject?.name}
                    </option>
                  ))}
              </select>

              <div style={{ color: "#668598", height: "45px", width: "43.5%" }}>
                <MultiSelect
                  options={studentList}
                  value={selectedList}
                  onChange={handleStudentSelection}
                  labelledBy="Select"
                  overrideStrings={{
                    selectSomeItems: "Select Students",
                  }}
                  // className="my-multi-select "
                  // style={{ width: "90%" }}
                />
              </div>
            </div>
          </div>
          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} className="input_group2"> */}
          {/* <button className="add_member_group">+ Add memeber</button> */}

          {/* </div> */}
          <Form.Group
            className="mb-3 w-100 "
            controlId="exampleForm.ControlTextarea1"
            style={{ paddingLeft: "0", paddingRight: "0", marginTop: "10px" }}
          >
            <Form.Control
              as="textarea"
              placeholder="Description"
              maxLength={250}
              rows={4}
              className="px-3 py-2 descri_activity text-left placeholderColor"
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
        </div>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: "90%" }}
        >
          <div className=" mt-2 d-flex gap-2 align-items-center">
            <img
              src={`${
                profile
                  ? URL.createObjectURL(profile)
                  : "/images/uploadBackgroundimg.png"
              }`}
              className="uploadImage view_first_upload_image"
              alt="uploadimg"
            />
            <div
              style={{ fontSize: "14px", fontWeight: "500" }}
              className="add_profile_group mt-4"
            >
              Add Profile Picture
            </div>
            <div className=" mt-4">
              <Popup
                on="click"
                open={showPopup}
                onClose={() => setShowPopup(false)}
                trigger={
                  // <img
                  //   src={assets.UploadIcon}
                  //   // className="cameraIcon"
                  //   alt="cameraIcon"

                  // />
                  <label
                    htmlFor={`attachFile`}
                    style={{
                      border: "1px solid #8D4B28",
                      color: "#8D4B28",
                      backgroundColor: "white",
                    }}
                    className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold mt-2"
                  >
                    <img
                      src={assets.UploadIcon}
                      height="100%"
                      width="25px"
                      alt="Attach Icon"
                      onClick={() => setShowPopup(true)}
                      style={{
                        objectFit: "contain",
                        cursor: "pointer",
                        maxHeight: "100%",
                      }}
                    />
                  </label>
                }
                content={
                  <div
                    style={{ width: "176px" }}
                    className="container_threedot"
                  >
                    <input
                      type="file"
                      id="attachFile"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      style={{ display: "none" }}
                      // onChange={(e) => {setProfile(e.target.files[0]); setShowPopup(false)}}
                      onChange={imageHandler}
                    />
                    <label htmlFor="attachFile">
                      <div className="PopupThreedots ">Upload New Image</div>
                    </label>
                    <div
                      onClick={(e) => {
                        setProfile(null);
                        setShowPopup(false);
                      }}
                      className="PopupThreedots"
                    >
                      Remove
                    </div>
                  </div>
                }
                position="bottom center"
              />
            </div>
            {!isValidFileType && (
              <p id="errorMsg">
                Please upload a file with a valid extension (JPG, JPEG, PNG) and
                file size should be less then 10MB.
              </p>
            )}
          </div>

          <div className="d-flex">
            <button
              disabled={
                !name ||
                !selectedList.length > 0 ||
                !sub ||
                !sec ||
                !stand ||
                !description
              }
              onClick={create}
              className="btn create_group_btn"
            >
              Create
            </button>
          </div>
        </div>
      </div>
      {createError && (
        <CreateGroupError
          setCreateError={setCreateError}
          errorMessage={errorMessage}
        />
      )}
    </div>
  );
}
